<template>
    <div :class="['form', 'form__listselect', `form__listselect--${size}`]">
        <div class="form__listselect_header">
            <base-filter
                :filter-data="items"
                :search-active="true"
                :search-placeholder="`${this.$t('forms.listSelect.filter.search')} ${name}`"
                :list-active="false"
                :actions-active="allowCreate"
                :actions-secondary-button-active="false"
                :actions-primary-button-text="`${this.$t('forms.listSelect.filter.add')} ${name}`"
                :overlay="false"
                @emit-filter-result="setFilterResult"
                @emit-actions-primary="createItem"
            />
        </div>
        <div class="form__listselect_main">
            <template v-if="items.length && outputItems">
                <form-list-select-table
                    :labels="labels"
                    :items="outputItems.length ? outputItems : items"
                    :actions-visible="actionsVisible"
                />
            </template>
            <template v-else-if="items.length && !outputItems">
                <component-empty-state
                    :item="'name'"
                    :title="`${this.$t('forms.listSelect.emptyState.titleNo')} ${name}${this.$t('forms.listSelect.emptyState.titleFound')}`"
                    :content="$t('forms.listSelect.emptyState.content')"
                    :submit-button-active="false"
                />
            </template>
            <template v-else>
                <component-empty-state
                    :item="'name'"
                    :title="`${this.$t('forms.listSelect.emptyState.titleNo')} ${name}${this.$t('forms.listSelect.emptyState.titleCreated')}`"
                    :content="''"
                    :submit-button-active="false"
                />
            </template>
        </div>
    </div>
</template>

<script>
import BaseFilter from '@/components/default/filters/BaseFilter'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import FormListSelectTable from '@/components/default/forms/FormListSelectTable'

export default {
  name: 'form-list-select',
  components: {
    FormListSelectTable,
    ComponentEmptyState,
    BaseFilter
  },
  data () {
    return {
      outputItems: [],
      selected: []
    }
  },
  props: {
    allowCreate: {
      type: Boolean,
      default: true
    },
    selectType: {
      type: String,
      default: 'multiple'
    },
    labels: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: 'item'
    },
    items: {
      type: [Object, Array],
      default: () => {}
    },
    actionsVisible: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    setFilterResult (data) {
      this.outputItems = data
    },
    createItem () {
      this.$emit('emit-create')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formlistselect";
</style>
